import { render, staticRenderFns } from "./UserSortTypes.vue?vue&type=template&id=3d2ee887&"
import script from "./UserSortTypes.vue?vue&type=script&lang=js&"
export * from "./UserSortTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports